// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tag_tagContainer__P1Qbn","tagText":"Tag_tagText__-RWyZ"};